import useWindowSize from "./useWindowSize";

export default function useWindowTargetWidth(targetWidth = 1200) {
    const windowSize = useWindowSize();
    const windowWidth = windowSize?.width;
    const screenWidth = window.screen.width;


    return { isSmallScreen: windowWidth <= targetWidth, screenCanReachTargetWidth: screenWidth >= targetWidth };
}